import type { ApolloClient } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import type { AppTypeEnum } from "../../../apiTypes";
import { clearTokens } from "../../helpers/tokens";
import { RefreshToken } from "../../queries/Token";
import type {
  RefreshTokenMutation,
  RefreshTokenMutationVariables,
} from "../../queries/Token.generated";

export const refreshAccessToken = async ({
  client,
  AppStorage,
}: {
  client: ApolloClient<unknown>;
  AppStorage: ToDo;
}): Promise<void | string> => {
  const refreshToken = AppStorage().get("refreshToken");
  if (!refreshToken) return;

  try {
    const { data } = await client?.mutate<RefreshTokenMutation, RefreshTokenMutationVariables>({
      mutation: RefreshToken,
      variables: { refresh_token: refreshToken },
    });

    if (data?.refreshToken) return data.refreshToken;
  } catch (_) {
    clearTokens({ AppStorage });
  }
};

const newFingerprint = (Date.now() * Math.random() ** 10).toString(36).slice(2, 31);

export const getAuthLink = ({
  appType,
  addSentryBreadcrumb,
  AppStorage,
}: {
  appType: AppTypeEnum;
  addSentryBreadcrumb: (message: string, options?: ToDo) => void;
  AppStorage: ToDo;
}) =>
  setContext((operation, previousContext) => {
    addSentryBreadcrumb(`[GraphQL Operation]: ${operation.operationName}`, {
      level: "info",
      category: "apiRequest",
      data: operation.variables,
    });

    const fingerprint = AppStorage().get("deviceFingerprint");

    if (!fingerprint) {
      AppStorage().set("deviceFingerprint", newFingerprint);
    }

    const countryCode = AppStorage().get("countryCode");
    const headerCode = countryCode === "NO" ? "NO" : "PL";
    const token = AppStorage().get("token");

    return {
      headers: {
        ...previousContext.headers,
        "X-App-Type": appType,
        "X-App-Country-Code": headerCode,
        "X-Device-Fingerprint": fingerprint || newFingerprint,
        Authorization: token ? `Bearer ${token}` : "",
      },
    };
  });
